import request from '@/utils/request'

let PointsApi = {
    /*积分设置*/
    setPoints(data, errorback) {
        return request._post('/shop/user.points/setting', data, errorback);
    },
    /*获取设置*/
    getPoints(data, errorback) {
        return request._get('/shop/user.points/setting', data, errorback);
    },
    /*获取积分列表*/
    GetUserList(data, errorback) {
        return request._get('/shop/user.points/log', data, errorback);
    },

    //保存积分兑换数值
    savePointNumber(data, errorback) {
        return request._get('/shop/user.points/savePointNumber', data, errorback);
    },

    //获取积分兑换数值列表
    getPointNumberList(data, errorback) {
        return request._get('/shop/user.points/getPointNumberList', data, errorback);
    },

    //删除数值
    deletePointNumber(data, errorback) {
        return request._get('/shop/user.points/deletePointNumber', data, errorback);
    },

}
export default PointsApi;



// WEBPACK FOOTER //
// ./src/api/points.js